/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fetchAPI, URL_API } from 'api';

const ROTA = '/forms/cicaaf';

export const CicaafAPI = {
  async getDataByID(uuid: string) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}`, 'GET');
  },

  async getAssociations() {
    return await fetchAPI(`${URL_API}${ROTA}/associations-cooperatives`, 'GET');
  },

  async updateBasicInfo(uuid: string, data: any) {
    return await fetchAPI(`${URL_API}${ROTA}/${uuid}/basic-info`, 'PUT', data);
  },

  async checkExisting(identification: string) {
    return await fetchAPI(
      `${URL_API}${ROTA}/check-existing?identification=${identification}`,
      'GET',
    );
  },

  async continueActiveCollection(identification: string) {
    return await fetchAPI(
      `${URL_API}${ROTA}/active/continue?identification=${identification}`,
      'GET',
    );
  },

  async copyFromPrevious(uuid: string) {
    return await fetchAPI(`${URL_API}${ROTA}/copy-from/${uuid}`, 'POST');
  },

  async createManualCollection(data: any) {
    return await fetchAPI(`${URL_API}${ROTA}`, 'POST', data);
  },

  checkHealth: async () => {
    return await fetchAPI(
      `${URL_API}${ROTA}/check-existing?identification=00000000000000`,
      'GET',
    );
  },

  async listAllProducts() {
    let page = 1;
    const take = 49;
    let allProducts: any[] = [];
    let hasMore = true;

    while (hasMore) {
      const response = await fetchAPI(
        `${URL_API}${ROTA}/products?page=${page}&take=${take}&sortBy=created_at&orderBy=DESC&withDeleted=false&active_only=true`,
        'GET'
      );

      const data = response.dados?.data || [];
      allProducts = [...allProducts, ...data];

      hasMore = data.length === take;
      page++;
    }

    return allProducts;
  },


  async updateProductionComercialization(
    collectionUuid: string,
    data: {
      products: Array<{
        product_uuid: string;
        commercialized_value: number;
        commercialized_volume: number;
        measurement_unit: string;
      }>;
      vegetal_license: {
        has_sanitary_license: boolean;
        license_number?: string;
        issuing_agency?: string;
        issue_date?: string;
      };
      animal_inspection: {
        has_inspection_register: boolean;
        inspection_seals?: Array<{
          inspection_seal: string;
          register_number: string;
          issue_date: string;
        }>;
      };
    },
  ) {
    return await fetchAPI(
      `${URL_API}${ROTA}/${collectionUuid}/production-commercialization`,
      'PUT',
      data,
    );
  },

  async getProductionComercialization(collectionUuid: string) {
    return await fetchAPI(
      `${URL_API}${ROTA}/${collectionUuid}/production-commercialization`,
      'GET',
    );
  },

  async updateProductionProcessed(
    collectionUuid: string,
    data: {
      processed_products: Array<{
        product_uuid: string;
        commercialized_value: number;
        commercialized_volume: number;
        measurement_unit: string;
      }>;
      vegetal_license: {
        has_sanitary_license: boolean;
        license_number?: string;
        issuing_agency?: string;
        issue_date?: string;
      };
      animal_inspection: {
        has_inspection_register: boolean;
        inspection_seals?: Array<{
          inspection_seal: string;
          register_number: string;
          issue_date: string;
        }>;
      };
    },
  ) {
    return await fetchAPI(
      `${URL_API}${ROTA}/${collectionUuid}/production-processed`,
      'PUT',
      data,
    );
  },

  async getProductionProcessed(collectionUuid: string) {
    return await fetchAPI(
      `${URL_API}${ROTA}/${collectionUuid}/production-processed`,
      'GET',
    );
  },
  async getCicaafCollection(collectionUuid: string) {
    return await fetchAPI(`${URL_API}${ROTA}/${collectionUuid}`, 'GET');
  },

  async cancelCollection(collectionUuid: string) {
    return await fetchAPI(
      `${URL_API}${ROTA}/${collectionUuid}/cancel`,
      'DELETE',
    );
  },

  async listCollections(filters?: {
    entity_name?: string;
    identification?: string;
    entity_type?: string;
    reference_year?: number;
  }) {
    const params = new URLSearchParams();
    if (filters?.entity_name) params.append('entity_name', filters.entity_name);
    if (filters?.identification) params.append('identification', filters.identification);
    if (filters?.entity_type) params.append('entity_type', filters.entity_type);
    if (filters?.reference_year) params.append('reference_year', filters.reference_year.toString());
    
    const queryString = params.toString();
    const url = `${URL_API}${ROTA}/municipal-manager/collections${queryString ? `?${queryString}` : ''}`;
    return await fetchAPI(url, 'GET');
  },

  async validateAndSendCollection(collectionUuid: string, payload: {
    statute_document_file_uuid: string;
    election_act_document_file_uuid: string;
    observations: string;
  }) {
    return await fetchAPI(
      `${URL_API}${ROTA}/municipal-manager/${collectionUuid}/validate-and-send`,
      'POST', payload
    );
  },

  async returnCollectionToMunicipality(
    collectionUuid: string,
    payload: {
      justification: string;
      data_hora: string;
      gerente_estadual: string;
    }
  ) {
    return await fetchAPI(
      `${URL_API}${ROTA}/${collectionUuid}/return-to-municipality`,
      'PUT',
      payload
    );
  },

  async updateCicaafCollection(collectionUuid: string, data: any) {
    return await fetchAPI(
      `${URL_API}${ROTA}/${collectionUuid}/validation-municipal`,
      'PUT',
      data
    );
  },

  async finalizeCollection(collectionUuid: string, data: any) {
    return await fetchAPI(
      `${URL_API}${ROTA}/${collectionUuid}/finalize`,
      'POST',
      data
    );
  }










};
